/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Type of section in the hub navigation (aligned with CompetitionType). Shared by Hub and Drop. NEWS, ENGAGEMENT and OFFICIAL_FOR are currently implemented on DropSection only — see DropSection's engagementType/engagementId; HubSection carries no engagement fields yet.
 * @export
 */
export const SurfaceSectionType = {
    GAMES: 'GAMES',
    MISSIONS: 'MISSIONS',
    TOURNAMENTS: 'TOURNAMENTS',
    LEAGUES: 'LEAGUES',
    LADDERS: 'LADDERS',
    LEADERBOARDS: 'LEADERBOARDS',
    GUILDS: 'GUILDS',
    CHALLENGES: 'CHALLENGES',
    CAMPAIGNS: 'CAMPAIGNS',
    STREAMING: 'STREAMING',
    INFO: 'INFO',
    EXCLUSIVES: 'EXCLUSIVES',
    CUSTOM: 'CUSTOM',
    NEWS: 'NEWS',
    ENGAGEMENT: 'ENGAGEMENT',
    OFFICIAL_FOR: 'OFFICIAL_FOR'
} as const;
export type SurfaceSectionType = typeof SurfaceSectionType[keyof typeof SurfaceSectionType];


export function instanceOfSurfaceSectionType(value: any): boolean {
    for (const key in SurfaceSectionType) {
        if (Object.prototype.hasOwnProperty.call(SurfaceSectionType, key)) {
            if (SurfaceSectionType[key as keyof typeof SurfaceSectionType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function SurfaceSectionTypeFromJSON(json: any): SurfaceSectionType {
    return SurfaceSectionTypeFromJSONTyped(json, false);
}

export function SurfaceSectionTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): SurfaceSectionType {
    return json as SurfaceSectionType;
}

export function SurfaceSectionTypeToJSON(value?: SurfaceSectionType | null): any {
    return value as any;
}

export function SurfaceSectionTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): SurfaceSectionType {
    return value as SurfaceSectionType;
}

